import { invoiceQueryKeys } from "./query-keys";
import { bulkUploadList } from "./bulk-upload/list";
import { bulkUploadEntity } from "./bulk-upload/entity";
import { bulkUploadUpload } from "./bulk-upload/upload";
import { bulkUploadBulkCreate } from "./bulk-upload/bulk-create";
import { bulkUploadsDownload } from "./bulk-upload/download";
import { crudCalculateFee } from "./crud/calculate-fee";
import { invoiceCreate } from "./crud/create-invoice";
import {
  recurringInvoiceCreate,
  recurringInvoiceList,
  recurringInvoiceActions,
} from "./recurring";

// Centralized invoice queries manager
export const invoiceQueries = {
  crud: {
    createInvoice: invoiceCreate,
    calculateFee: crudCalculateFee,
  },
  bulkUpload: {
    list: bulkUploadList,
    entity: bulkUploadEntity,
    upload: bulkUploadUpload,
    bulkCreate: bulkUploadBulkCreate,
    download: bulkUploadsDownload,
  },
  recurringInvoice: {
    create: recurringInvoiceCreate,
    list: recurringInvoiceList,
    actions: recurringInvoiceActions,
  },
};

// Export queryKeys separately for direct access if needed
export { invoiceQueryKeys };
